export default __webpack_public_path__ + "static/screen_popup-2e746c27ecb84926d553338a22e919c5.mp4";